var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoblancosolo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 529.05,
    height: 296.341,
    viewBox: "0 0 529.05 296.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_52",
    "data-name": "Rect\\xE1ngulo 52",
    width: 222.192,
    height: 8.297,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -21.771,
    y1: 705.025,
    x2: -21.754,
    y2: 705.025,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#209f37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#229f36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#44a72f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5ead2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#71b226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#7db524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#81b624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#b7c91c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#aac408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#1c9f38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c9f38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_54",
    "data-name": "Rect\\xE1ngulo 54",
    width: 151.693,
    height: 8.297,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -33.192,
    y1: 706.53,
    x2: -33.167,
    y2: 706.53,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85468d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#975897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#aa6ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#b676a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ba7aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#bb4a8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#8e488e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#cd006a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd006a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_56",
    "data-name": "Rect\\xE1ngulo 56",
    width: 95.961,
    height: 8.297,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -53.58,
    y1: 709.285,
    x2: -53.54,
    y2: 709.285,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d66a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "#2a78b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#3c92cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#4aa5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#52b1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#55b5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#4272b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#81c0e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e3c8a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_58",
    "data-name": "Rect\\xE1ngulo 58",
    width: 59.207,
    height: 8.297,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -87.174,
    y1: 713.94,
    x2: -87.11,
    y2: 713.94,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea8018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#ea8416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#f09e0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#f3b105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#f6bd01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#f7c100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#ea8934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#e26031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc312d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M1349.724-215.77a6.54,6.54,0,0,0-2,2.117c-2.212,3.592-4.336,7.244-6.781,11.365,1.049-.133,1.752-.224,2.452-.312,7.457-.893,14.9-1.946,22.368-2.619,5.61-.506,13-6.055,15.081-11.84-3.42-1.7-8.472-2.524-13.679-2.524-6.548,0-13.345,1.3-17.446,3.812",
    transform: "translate(-1340.947 219.582)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -120.331,
    y1: 353.609,
    x2: -120.236,
    y2: 353.609,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M1348.288-211.617c.73.239.939.4,1.094.346,10.126-3.1,20.339-4.314,30.7-2.68a2.316,2.316,0,0,0,1.95-.62c3.09-4.911,6.066-9.9,9.51-15.576-1.3-.08-2.565-.118-3.82-.118-15.85,0-28.529,6.363-39.438,18.647",
    transform: "translate(-1348.288 230.264)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -112.169,
    y1: 322.669,
    x2: -112.081,
    y2: 322.669,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M1357.032-221.265c-5.842,1.539-9.251,5.542-12.532,10.791.73.133,1.034.289,1.292.224a69.034,69.034,0,0,1,29.2-1.258,2.357,2.357,0,0,0,1.786-.274,43.919,43.919,0,0,0,9.454-11.741,29.715,29.715,0,0,0-7.211-.711,94.82,94.82,0,0,0-21.988,2.969",
    transform: "translate(-1344.5 224.233)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -115.694,
    y1: 436.121,
    x2: -115.603,
    y2: 436.121,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M1344.532-209.132c-4.151,2.9-5.846,7.4-6.123,12.794,6.127-1.463,11.806-2.965,17.533-4.151,6.838-1.418,10.2-6.682,13.6-12.866a35.751,35.751,0,0,0-8.5-1.087,28.075,28.075,0,0,0-16.507,5.31",
    transform: "translate(-1338.409 214.442)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -151.258,
    y1: 339.055,
    x2: -151.136,
    y2: 339.055,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M1375.819-247.817c-3.755,7.085-6.811,14.728-11.429,21.125-7.1,9.818-6.093,21.6-9.631,32.224A108.44,108.44,0,0,0,1377-250.128c-.4.768-.783,1.547-1.186,2.311",
    transform: "translate(-1354.758 250.128)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -207.647,
    y1: 114.088,
    x2: -207.476,
    y2: 114.088,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#066b30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#0d6f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.061,
    stopColor: "#2f862e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114,
    stopColor: "#49972e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#5ca42d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#68ab2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#6cae2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#4fa732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#80b526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80b526"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M1353.647-213.672a63.081,63.081,0,0,1,24.288-4.751,3.081,3.081,0,0,0,2.087-1.547,39.248,39.248,0,0,0,4.436-17.366,79.387,79.387,0,0,0-30.811,23.664",
    transform: "translate(-1353.647 237.336)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -154.575,
    y1: 263.143,
    x2: -154.451,
    y2: 263.143,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M1338.43-196.728a36.6,36.6,0,0,0,.186,18.75c6.439-10.217,12.692-20.149,19-30.164a2.452,2.452,0,0,0-.806-.376,16.659,16.659,0,0,0-4.245-.57c-6.8,0-12.266,4.622-14.132,12.361",
    transform: "translate(-1337.303 209.088)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -134.841,
    y1: 263.185,
    x2: -134.726,
    y2: 263.185,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M1353.174-227.491c-.635,4.322-1.224,8.662-2.17,12.919-1.3,5.876-2.908,11.684-4.581,18.305,12.075-4.109,17.914-31.255,14.154-40.122-2.706,2.835-6.716,4.2-7.4,8.9",
    transform: "translate(-1346.423 236.389)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -242.64,
    y1: 160.016,
    x2: -242.428,
    y2: 160.016,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M1337.234-168.027a1.7,1.7,0,0,0,.825-1.079c2.517-11.954,5.178-23.885,7.446-35.888.92-4.888.2-9.78-2.4-15.09-6.507,17.476-8.541,34.535-5.872,52.057",
    transform: "translate(-1336.093 220.084)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -326.655,
    y1: 126.343,
    x2: -326.335,
    y2: 126.343,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M1340.195-213.424a7.065,7.065,0,0,0-.532,4.451,72.883,72.883,0,0,1,1.368,25.036c7.032-6.024,11.928-34.463,7.256-43.725-2.892,5.032-5.637,9.555-8.092,14.238",
    transform: "translate(-1339.515 227.662)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -292.434,
    y1: 150.007,
    x2: -292.154,
    y2: 150.007,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M1350.565-229.337c-3.322,2.908-5.124,6.275-4.531,11.049a39.855,39.855,0,0,1-.368,9.327c-.669,5.85-1.562,11.676-2.376,17.556,7.507-4.063,15.367-28.887,10.4-40.879-1.072,1.011-2.068,2.018-3.128,2.946",
    transform: "translate(-1343.29 232.283)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -268.099,
    y1: 159.335,
    x2: -267.852,
    y2: 159.335,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M1357.334-207.6c.068.205.14.41.205.616q8.421-7.206,16.819-14.44a2.466,2.466,0,0,0,.707-1.463,90.094,90.094,0,0,0-1-23.619c-5.614,13.052-11.174,25.979-16.731,38.906",
    transform: "translate(-1357.334 246.508)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -242.44,
    y1: 161.874,
    x2: -242.236,
    y2: 161.874,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M1355.538-233.308a4.1,4.1,0,0,0-1.03,2.265c-1.156,9.4-2.246,18.807-3.353,28.18,3.7-3.044,7.267-6.731,8.559-12.132,1.148-4.789,2.2-9.612,2.977-14.47.547-3.4.57-6.868.9-11.19-3.223,2.919-5.694,5.067-8.051,7.347",
    transform: "translate(-1351.156 240.655)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -336.79,
    y1: 172.688,
    x2: -336.484,
    y2: 172.688,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4714",
    "data-name": "Grupo 4714",
    transform: "translate(-3684.825 1179.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_138",
    "data-name": "Trazado 138",
    d: "M1286.747-197.233h15.747l22.353,36.542H1325v-36.542h11.585v52.582H1321.43l-22.95-37.431h-.148v37.431h-11.585Z",
    transform: "translate(2398.356 -781.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_139",
    "data-name": "Trazado 139",
    d: "M1301.928-169.956a29.724,29.724,0,0,1,2.121-11.437,25.1,25.1,0,0,1,5.9-8.727,26.06,26.06,0,0,1,8.985-5.534,32.456,32.456,0,0,1,11.365-1.931,32.449,32.449,0,0,1,11.361,1.931,26.052,26.052,0,0,1,8.985,5.534,25.1,25.1,0,0,1,5.907,8.727,29.714,29.714,0,0,1,2.117,11.437,29.713,29.713,0,0,1-2.117,11.437,25.1,25.1,0,0,1-5.907,8.727,26,26,0,0,1-8.985,5.534,32.449,32.449,0,0,1-11.361,1.931,32.456,32.456,0,0,1-11.365-1.931,26,26,0,0,1-8.985-5.534,25.1,25.1,0,0,1-5.9-8.727,29.723,29.723,0,0,1-2.121-11.437m12.034,0a19.274,19.274,0,0,0,1.151,6.8,15.526,15.526,0,0,0,3.3,5.344,15.117,15.117,0,0,0,5.162,3.531,17.246,17.246,0,0,0,6.723,1.262,17.233,17.233,0,0,0,6.72-1.262,15.082,15.082,0,0,0,5.162-3.531,15.51,15.51,0,0,0,3.3-5.344,19.2,19.2,0,0,0,1.156-6.8,19.286,19.286,0,0,0-1.156-6.758,15.514,15.514,0,0,0-3.3-5.386,15.124,15.124,0,0,0-5.162-3.527,17.232,17.232,0,0,0-6.72-1.262,17.246,17.246,0,0,0-6.723,1.262,15.16,15.16,0,0,0-5.162,3.527,15.53,15.53,0,0,0-3.3,5.386,19.363,19.363,0,0,0-1.151,6.758",
    transform: "translate(2440.878 -782.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_140",
    "data-name": "Trazado 140",
    d: "M1317.56-197.233h13.22l12.995,34.459h.153l13.219-34.459h12.4l-21.688,52.582h-9.281Z",
    transform: "translate(2484.661 -781.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_141",
    "data-name": "Trazado 141",
    d: "M1352.909-197.233h9.578l22.878,52.582h-13.072l-4.531-11.14h-20.426l-4.383,11.14h-12.771Zm4.455,15.3-6.385,16.336h12.847Z",
    transform: "translate(2520.017 -781.627)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_142",
    "data-name": "Trazado 142",
    d: "M1382.555-182.583a11.407,11.407,0,0,0-4.2-3.193,13.938,13.938,0,0,0-5.759-1.114,14.5,14.5,0,0,0-6.051,1.262,14.494,14.494,0,0,0-4.827,3.527,16.465,16.465,0,0,0-3.192,5.386,19.35,19.35,0,0,0-1.152,6.758,19.239,19.239,0,0,0,1.152,6.792,16.917,16.917,0,0,0,3.154,5.348,14.3,14.3,0,0,0,4.717,3.531,13.657,13.657,0,0,0,5.83,1.262,13.1,13.1,0,0,0,6.313-1.486,12.572,12.572,0,0,0,4.527-4.158l9.658,7.2a20.07,20.07,0,0,1-8.468,6.906,26.179,26.179,0,0,1-10.544,2.231,32.455,32.455,0,0,1-11.364-1.931,26,26,0,0,1-8.985-5.534,25.083,25.083,0,0,1-5.9-8.727,29.659,29.659,0,0,1-2.121-11.437,29.679,29.679,0,0,1,2.121-11.441,25.069,25.069,0,0,1,5.9-8.723,26,26,0,0,1,8.985-5.534,32.455,32.455,0,0,1,11.364-1.931,27.706,27.706,0,0,1,4.642.41,24.97,24.97,0,0,1,4.751,1.3,21.633,21.633,0,0,1,4.5,2.376,18.283,18.283,0,0,1,3.861,3.641Z",
    transform: "translate(2562.481 -782.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_143",
    "data-name": "Trazado 143",
    d: "M1359.59-197.233h35.721v10.7h-24.136v9.8h22.8v10.7h-22.8v10.7h25.474v10.692H1359.59Z",
    transform: "translate(2602.382 -781.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_144",
    "data-name": "Trazado 144",
    d: "M1371.782-197.233h15.747l22.349,36.542h.152v-36.542h11.582v52.582h-15.147l-22.95-37.431h-.148v37.431h-11.585Z",
    transform: "translate(2636.532 -781.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_145",
    "data-name": "Trazado 145",
    d: "M1401.439-186.983h-15v-10.251h41.586v10.251h-15v42.331h-11.585Z",
    transform: "translate(2677.577 -781.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_146",
    "data-name": "Trazado 146",
    d: "M1398.921-197.233h20.35a35.872,35.872,0,0,1,7.613.779,18.152,18.152,0,0,1,6.313,2.6,13.016,13.016,0,0,1,4.307,4.9,16.584,16.584,0,0,1,1.593,7.685,15.428,15.428,0,0,1-2.892,9.468,13.054,13.054,0,0,1-8.469,4.941l13.368,22.2h-13.889l-10.988-21.019h-5.721v21.019h-11.585Zm11.585,21.76h6.834c1.038,0,2.136-.038,3.3-.11a10.349,10.349,0,0,0,3.154-.669A5.48,5.48,0,0,0,1426.14-178a5.341,5.341,0,0,0,.928-3.341,5.594,5.594,0,0,0-.813-3.2,5.506,5.506,0,0,0-2.083-1.817,9.189,9.189,0,0,0-2.9-.855,23.632,23.632,0,0,0-3.193-.224h-7.576Z",
    transform: "translate(2712.545 -781.627)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_147",
    "data-name": "Trazado 147",
    d: "M1410.841-169.956a29.714,29.714,0,0,1,2.117-11.437,25.086,25.086,0,0,1,5.9-8.727,26.089,26.089,0,0,1,8.993-5.534,32.433,32.433,0,0,1,11.361-1.931,32.445,32.445,0,0,1,11.36,1.931,26.047,26.047,0,0,1,8.985,5.534,25.1,25.1,0,0,1,5.907,8.727,29.725,29.725,0,0,1,2.117,11.437,29.725,29.725,0,0,1-2.117,11.437,25.1,25.1,0,0,1-5.907,8.727,25.991,25.991,0,0,1-8.985,5.534,32.445,32.445,0,0,1-11.36,1.931,32.433,32.433,0,0,1-11.361-1.931,26.032,26.032,0,0,1-8.993-5.534,25.086,25.086,0,0,1-5.9-8.727,29.713,29.713,0,0,1-2.117-11.437m12.03,0a19.283,19.283,0,0,0,1.152,6.8,15.576,15.576,0,0,0,3.3,5.344,15.12,15.12,0,0,0,5.162,3.531,17.248,17.248,0,0,0,6.724,1.262,17.241,17.241,0,0,0,6.72-1.262,15.082,15.082,0,0,0,5.162-3.531,15.456,15.456,0,0,0,3.3-5.344,19.283,19.283,0,0,0,1.155-6.8,19.373,19.373,0,0,0-1.155-6.758,15.46,15.46,0,0,0-3.3-5.386,15.125,15.125,0,0,0-5.162-3.527,17.241,17.241,0,0,0-6.72-1.262,17.247,17.247,0,0,0-6.724,1.262,15.163,15.163,0,0,0-5.162,3.527,15.579,15.579,0,0,0-3.3,5.386,19.372,19.372,0,0,0-1.152,6.758",
    transform: "translate(2745.931 -782.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_148",
    "data-name": "Trazado 148",
    d: "M1301.59-177.874h7.446a8.7,8.7,0,0,1,3.349.555,5.68,5.68,0,0,1,2.079,1.406,4.746,4.746,0,0,1,1.06,1.912,7.482,7.482,0,0,1,.3,2.049,7.482,7.482,0,0,1-.3,2.049,4.786,4.786,0,0,1-1.06,1.916,5.72,5.72,0,0,1-2.079,1.4,8.7,8.7,0,0,1-3.349.555h-4.576v9.331h-2.87Zm2.87,9.331h3.771a10.506,10.506,0,0,0,1.657-.133,4.512,4.512,0,0,0,1.468-.494,2.691,2.691,0,0,0,1.03-1.034,3.47,3.47,0,0,0,.391-1.748,3.47,3.47,0,0,0-.391-1.748,2.655,2.655,0,0,0-1.03-1.03,4.34,4.34,0,0,0-1.468-.494,10.074,10.074,0,0,0-1.657-.137h-3.771Z",
    transform: "translate(2439.932 -727.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_149",
    "data-name": "Trazado 149",
    d: "M1317.063-177.874h2.6l9.061,21.175h-3.349l-2.125-5.234h-10.076l-2.094,5.234h-3.349Zm5.146,13.429-3.949-9.723h-.057l-4.01,9.723Z",
    transform: "translate(2457.142 -727.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_150",
    "data-name": "Trazado 150",
    d: "M1318.076-160.732a4.734,4.734,0,0,0,1.988,1.722,5.962,5.962,0,0,0,2.5.551,5.008,5.008,0,0,0,1.467-.224,4.51,4.51,0,0,0,1.361-.673,3.776,3.776,0,0,0,1-1.106,2.983,2.983,0,0,0,.388-1.528,2.291,2.291,0,0,0-.78-1.866,6.7,6.7,0,0,0-1.927-1.076c-.772-.293-1.608-.57-2.512-.84a10.072,10.072,0,0,1-2.513-1.121,6.149,6.149,0,0,1-1.931-1.927,6.031,6.031,0,0,1-.779-3.276,5.5,5.5,0,0,1,.407-1.973,5.578,5.578,0,0,1,1.27-1.916,7.016,7.016,0,0,1,2.228-1.448,8.252,8.252,0,0,1,3.276-.582,11.41,11.41,0,0,1,3.318.479,5.7,5.7,0,0,1,2.782,1.939l-2.334,2.125a3.847,3.847,0,0,0-1.524-1.345,4.835,4.835,0,0,0-2.242-.509,5.432,5.432,0,0,0-1.987.315,3.559,3.559,0,0,0-1.274.81,2.811,2.811,0,0,0-.673,1.06,3.254,3.254,0,0,0-.194,1.045,2.67,2.67,0,0,0,.779,2.064,6.02,6.02,0,0,0,1.927,1.167,23.875,23.875,0,0,0,2.512.806,10.874,10.874,0,0,1,2.512,1,5.9,5.9,0,0,1,1.932,1.733,5.128,5.128,0,0,1,.775,3.006,6.334,6.334,0,0,1-.582,2.752,6.147,6.147,0,0,1-1.569,2.064,6.978,6.978,0,0,1-2.334,1.285,8.985,8.985,0,0,1-2.87.449,10.49,10.49,0,0,1-3.858-.715,6.348,6.348,0,0,1-2.9-2.216Z",
    transform: "translate(2479.485 -727.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_151",
    "data-name": "Trazado 151",
    d: "M1331.355-177.874h2.6l9.058,21.175h-3.349l-2.125-5.234h-10.076l-2.094,5.234h-3.349Zm5.142,13.429-3.949-9.723h-.057l-4.006,9.723Z",
    transform: "translate(2497.161 -727.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_152",
    "data-name": "Trazado 152",
    d: "M1338.874-177.874h2.87v15.131a7.412,7.412,0,0,1-.627,3.276,5.708,5.708,0,0,1-1.569,2,5.625,5.625,0,0,1-2.019,1.015,7.774,7.774,0,0,1-1.976.285,6.135,6.135,0,0,1-3.782-1.152,5.308,5.308,0,0,1-1.958-3.485l2.809-.627a3.388,3.388,0,0,0,.988,1.885,2.77,2.77,0,0,0,1.942.688,3.137,3.137,0,0,0,1.722-.418,2.925,2.925,0,0,0,1-1.095,4.535,4.535,0,0,0,.475-1.539,12.783,12.783,0,0,0,.122-1.764Z",
    transform: "translate(2518.978 -727.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_153",
    "data-name": "Trazado 153",
    d: "M1336.437-177.874h13.668v2.691h-10.8v6.31h10.05v2.691h-10.05v6.788h11.334v2.691h-14.2Z",
    transform: "translate(2537.533 -727.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_154",
    "data-name": "Trazado 154",
    d: "M1363.52-172.9a5.877,5.877,0,0,0-2.273-1.794,6.714,6.714,0,0,0-2.839-.631,7.621,7.621,0,0,0-3.246.677,7.471,7.471,0,0,0-2.482,1.836,8.446,8.446,0,0,0-1.6,2.737,9.812,9.812,0,0,0-.567,3.368,9.313,9.313,0,0,0,.536,3.166,7.894,7.894,0,0,0,1.554,2.634,7.309,7.309,0,0,0,2.482,1.794,7.989,7.989,0,0,0,3.322.658,6.613,6.613,0,0,0,3.2-.745,6.915,6.915,0,0,0,2.33-2.094l2.425,1.824a10.344,10.344,0,0,1-.84.943,8.422,8.422,0,0,1-1.585,1.224,11.285,11.285,0,0,1-2.375,1.076,10.1,10.1,0,0,1-3.216.464,10.435,10.435,0,0,1-4.531-.958,10.929,10.929,0,0,1-3.439-2.509,10.958,10.958,0,0,1-2.167-3.516,10.95,10.95,0,0,1-.749-3.961,12.45,12.45,0,0,1,.806-4.531,10.652,10.652,0,0,1,2.261-3.588,10.07,10.07,0,0,1,3.482-2.349,11.667,11.667,0,0,1,4.485-.836,11.033,11.033,0,0,1,4.112.806,7.661,7.661,0,0,1,3.3,2.482Z",
    transform: "translate(2568.408 -727.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_155",
    "data-name": "Trazado 155",
    d: "M1366.221-155.766a11.443,11.443,0,0,1-4.454-.851,10.439,10.439,0,0,1-3.485-2.349,10.863,10.863,0,0,1-2.273-3.527,11.642,11.642,0,0,1-.821-4.4,11.622,11.622,0,0,1,.821-4.394,10.839,10.839,0,0,1,2.273-3.531,10.439,10.439,0,0,1,3.485-2.349,11.444,11.444,0,0,1,4.454-.851,11.443,11.443,0,0,1,4.455.851,10.4,10.4,0,0,1,3.485,2.349,10.915,10.915,0,0,1,2.277,3.531,11.683,11.683,0,0,1,.818,4.394,11.7,11.7,0,0,1-.818,4.4,10.94,10.94,0,0,1-2.277,3.527,10.4,10.4,0,0,1-3.485,2.349,11.442,11.442,0,0,1-4.455.851m0-2.691a7.8,7.8,0,0,0,3.288-.673,7.786,7.786,0,0,0,2.512-1.809,7.935,7.935,0,0,0,1.616-2.676,9.367,9.367,0,0,0,.57-3.276,9.382,9.382,0,0,0-.57-3.276,7.935,7.935,0,0,0-1.616-2.676,7.785,7.785,0,0,0-2.512-1.809,7.852,7.852,0,0,0-3.288-.673,7.845,7.845,0,0,0-3.288.673,7.793,7.793,0,0,0-2.513,1.809,7.948,7.948,0,0,0-1.615,2.676,9.377,9.377,0,0,0-.57,3.276,9.361,9.361,0,0,0,.57,3.276,7.949,7.949,0,0,0,1.615,2.676,7.794,7.794,0,0,0,2.513,1.809,7.787,7.787,0,0,0,3.288.673",
    transform: "translate(2590.051 -727.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_156",
    "data-name": "Trazado 156",
    d: "M1364.211-177.874h4.276l6.731,16.029h.121l6.667-16.029h4.276V-156.7h-2.87v-17.4h-.061l-7.15,17.4h-1.911l-7.15-17.4h-.057v17.4h-2.874Z",
    transform: "translate(2615.325 -727.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_157",
    "data-name": "Trazado 157",
    d: "M1373.582-177.874h13.668v2.691h-10.794v6.31H1386.5v2.691h-10.045v6.788h11.33v2.691h-14.2Z",
    transform: "translate(2641.572 -727.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_158",
    "data-name": "Trazado 158",
    d: "M1380.577-177.874h7.446a8.734,8.734,0,0,1,3.352.555,5.658,5.658,0,0,1,2.075,1.406,4.744,4.744,0,0,1,1.064,1.912,7.606,7.606,0,0,1,.3,2.049,5.439,5.439,0,0,1-.358,1.957,5.6,5.6,0,0,1-1.03,1.707,5.93,5.93,0,0,1-1.65,1.285,5.685,5.685,0,0,1-2.166.642l6.013,9.662h-3.588l-5.382-9.331h-3.2v9.331h-2.87Zm2.87,9.331h3.77a10.567,10.567,0,0,0,1.661-.133,4.491,4.491,0,0,0,1.463-.494,2.676,2.676,0,0,0,1.034-1.034,3.515,3.515,0,0,0,.388-1.748,3.515,3.515,0,0,0-.388-1.748,2.641,2.641,0,0,0-1.034-1.03,4.32,4.32,0,0,0-1.463-.494,10.132,10.132,0,0,0-1.661-.137h-3.77Z",
    transform: "translate(2661.166 -727.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_159",
    "data-name": "Trazado 159",
    d: "M1403.288-172.9a5.9,5.9,0,0,0-2.273-1.794,6.744,6.744,0,0,0-2.843-.631,7.614,7.614,0,0,0-3.242.677,7.481,7.481,0,0,0-2.486,1.836,8.443,8.443,0,0,0-1.6,2.737,9.807,9.807,0,0,0-.57,3.368,9.314,9.314,0,0,0,.54,3.166,7.844,7.844,0,0,0,1.555,2.634,7.308,7.308,0,0,0,2.482,1.794,7.981,7.981,0,0,0,3.318.658,6.592,6.592,0,0,0,3.2-.745,6.929,6.929,0,0,0,2.334-2.094l2.421,1.824a10.27,10.27,0,0,1-.836.943,8.456,8.456,0,0,1-1.585,1.224,11.216,11.216,0,0,1-2.379,1.076,10.085,10.085,0,0,1-3.212.464,10.465,10.465,0,0,1-4.535-.958,10.958,10.958,0,0,1-3.436-2.509,10.953,10.953,0,0,1-2.167-3.516,10.968,10.968,0,0,1-.752-3.961,12.451,12.451,0,0,1,.809-4.531,10.711,10.711,0,0,1,2.258-3.588,10.113,10.113,0,0,1,3.485-2.349,11.651,11.651,0,0,1,4.485-.836,11.036,11.036,0,0,1,4.113.806,7.69,7.69,0,0,1,3.3,2.482Z",
    transform: "translate(2679.785 -727.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_50",
    "data-name": "Rect\\xE1ngulo 50",
    width: 2.87,
    height: 21.171,
    transform: "translate(4097.697 -905.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_160",
    "data-name": "Trazado 160",
    d: "M1408.292-177.874h2.6l9.062,21.175h-3.349l-2.125-5.234h-10.076l-2.094,5.234h-3.349Zm5.147,13.429-3.949-9.723h-.061l-4,9.723Z",
    transform: "translate(2712.668 -727.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_161",
    "data-name": "Trazado 161",
    d: "M1407.4-177.874h2.873v18.48h9.719v2.691H1407.4Z",
    transform: "translate(2736.291 -727.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_116",
    "data-name": "Grupo 116",
    transform: "translate(3684.825 -920.924)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_51",
    "data-name": "Rect\\xE1ngulo 51",
    width: 222.192,
    height: 8.297,
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_117",
    "data-name": "Grupo 117",
    transform: "translate(3907.017 -920.924)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_53",
    "data-name": "Rect\\xE1ngulo 53",
    width: 151.694,
    height: 8.297,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_118",
    "data-name": "Grupo 118",
    transform: "translate(4058.707 -920.924)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_55",
    "data-name": "Rect\\xE1ngulo 55",
    width: 95.961,
    height: 8.297,
    transform: "translate(0)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_119",
    "data-name": "Grupo 119",
    transform: "translate(4154.668 -920.924)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_57",
    "data-name": "Rect\\xE1ngulo 57",
    width: 59.207,
    height: 8.297,
    transform: "translate(0)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_120",
    "data-name": "Grupo 120",
    transform: "translate(3872.663 -1179.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M1438.229-240.022h-34.877v91.792c-10.255-12.5-20.677-26.321-30.141-37.861-2.109,4.991-5.374,9.115-8.438,13.653a69.763,69.763,0,0,1-13.105,14.021c18.845,22.954,37.484,45.675,56.181,68.351a4.848,4.848,0,0,0,2.976,1.9c9.077.152,18.153.091,27.4.091Z",
    transform: "translate(-1293.471 280.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M1337.795-167.118V-240.08c9.328,0,18.56-.068,27.788.091.984.015,2.132,1.182,2.888,2.071,3.58,4.23,8.354,8.084,12.353,12.969-10.73,9.023-16.826,15.4-27.191,28.815-5.515,7.134-13.5,20.24-15.839,29.016",
    transform: "translate(-1331.325 278.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28",
    transform: "translate(18.45 116.102)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_14",
    "data-name": "Rect\\xE1ngulo 14",
    width: 39.902,
    height: 17.294,
    transform: "translate(0.001 -0.001)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(46.349 75.501)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_15",
    "data-name": "Rect\\xE1ngulo 15",
    width: 43.258,
    height: 19.043,
    transform: "translate(0.001 -0.001)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_32",
    "data-name": "Grupo 32",
    transform: "translate(31.955 98.424)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_16",
    "data-name": "Rect\\xE1ngulo 16",
    width: 41.73,
    height: 14.048,
    transform: "translate(0.001 -0.001)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34",
    transform: "translate(8.804 135.639)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17",
    "data-name": "Rect\\xE1ngulo 17",
    width: 31.129,
    height: 18.103,
    transform: "translate(0.001 -0.001)",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_36",
    "data-name": "Grupo 36",
    transform: "translate(70.945)",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_18",
    "data-name": "Rect\\xE1ngulo 18",
    width: 22.246,
    height: 55.661,
    transform: "translate(0.001 -0.001)",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_38",
    "data-name": "Grupo 38",
    transform: "translate(66.721 48.621)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_19",
    "data-name": "Rect\\xE1ngulo 19",
    width: 30.81,
    height: 23.664,
    transform: "translate(0.001 0)",
    fill: "url(#linear-gradient-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_40",
    "data-name": "Grupo 40",
    transform: "translate(4.597 155.989)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_20",
    "data-name": "Rect\\xE1ngulo 20",
    width: 33.137,
    height: 23.999,
    transform: "translate(-3.705 30.762) rotate(-83.936)",
    fill: "url(#linear-gradient-11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42",
    "data-name": "Grupo 42",
    transform: "translate(39.264 52.22)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_21",
    "data-name": "Rect\\xE1ngulo 21",
    width: 17.914,
    height: 40.122,
    transform: "translate(0.001 -0.001)",
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_44",
    "data-name": "Grupo 44",
    transform: "translate(0 114.194)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22",
    "data-name": "Rect\\xE1ngulo 22",
    width: 11.859,
    height: 52.057,
    transform: "translate(-1.526 -0.001)",
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_46",
    "data-name": "Grupo 46",
    transform: "translate(13.009 85.391)",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_23",
    "data-name": "Rect\\xE1ngulo 23",
    width: 13.611,
    height: 43.726,
    transform: "translate(-0.167 -0.001)",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_48",
    "data-name": "Grupo 48",
    transform: "translate(27.356 67.827)",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24",
    "data-name": "Rect\\xE1ngulo 24",
    width: 15.367,
    height: 40.879,
    transform: "translate(0.001 0)",
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_50",
    "data-name": "Grupo 50",
    transform: "translate(80.736 13.759)",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25",
    "data-name": "Rect\\xE1ngulo 25",
    width: 18.598,
    height: 39.521,
    transform: "translate(0.001 0)",
    fill: "url(#linear-gradient-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_52",
    "data-name": "Grupo 52",
    transform: "translate(57.254 36.006)",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_26",
    "data-name": "Rect\\xE1ngulo 26",
    width: 12.433,
    height: 37.792,
    transform: "translate(0.001 -0.001)",
    fill: "url(#linear-gradient-17)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45",
    "data-name": "Trazado 45",
    d: "M1373.784-214.064l-.4,53.163h-35.557l17.978-28.1",
    transform: "translate(-1331.237 351.139)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoblancosolo);
export default __webpack_public_path__ + "static/media/logoblancosolo.c3241b8a81b2213778fda1b4e17cfbf0.svg";
export { ForwardRef as ReactComponent };